import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["expandableIcon"]

  toggleHiddenRows () {
    this.element.classList.toggle("tablev2__row--expandable--expanded")
    const rows = this._rowsToExpand()
    rows.forEach((row, index) => {
      row.classList.toggle("d-none")
      if (index < rows.length - 1) {
        row.classList.toggle("tablev2__row--subrow-expanded")
      }
    })
  }

  _rowsToExpand () {
    const rows = []
    let nextSibling = this.element.nextElementSibling

    while (nextSibling && nextSibling.matches("[data-table-row-expandable-target='row']")) {
      rows.push(nextSibling)
      nextSibling = nextSibling.nextElementSibling
    }

    return rows
  }
}
